<app-license-banner></app-license-banner>
<ng-template component-host></ng-template>
<app-load-layout></app-load-layout>